export const DEFAULT_PAGE_SIZE = 15;

/** Returns the stored page size, or the default when it isn't a positive integer. */
export function parseStoredPageSize(value: unknown): number {
  if (typeof value === "number" && Number.isInteger(value) && value > 0) {
    return value;
  }

  return DEFAULT_PAGE_SIZE;
}
